'use client';

const errorAnnouncement = (label, error) => `${label} error: ${error}`;
export {
  errorAnnouncement
};
